import { Link } from "react-router-dom";
import { Download, FileText } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { Empty, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";
import { CouponTicket } from "@/components/RxSheet";

export default function Records() {
  const { data } = useFetch("/rx/customer/records");
  if (!data) return <Spinner />;
  return (
    <div className="space-y-6">
      <PageHead eyebrow="My records" title="Coupons & e-RX" actions={<Link to="/app/gia" className="btn-primary" data-testid="ask-gia-link">Ask GIA (remote consult)</Link>} />
      <section className="space-y-3" data-testid="customer-coupons">
        <h2 className="text-sm font-bold">Free appointment coupons</h2>
        {!data.coupons.length ? <Empty title="No coupons yet" hint="Coupons appear here when your package includes them." /> : data.coupons.map((c) => (
          <div key={c.code} className="space-y-1"><CouponTicket c={c} />
            <Link to={`/print/coupon/${c.code}`} className="btn-ghost btn-sm" data-testid={`coupon-download-${c.code}`}><Download size={13} /> Download coupon</Link></div>
        ))}
      </section>
      <section className="space-y-2" data-testid="customer-prescriptions">
        <h2 className="text-sm font-bold">e-RX</h2>
        {!data.prescriptions.length ? <Empty title="No prescriptions yet" /> : data.prescriptions.map((r) => (
          <Link key={r.number} to={`/print/rx/${r.number}`} className="surface flex items-center justify-between gap-3 p-4" data-testid={`customer-rx-${r.number}`}>
            <span className="flex items-center gap-3"><FileText size={18} className="text-purple-600" /><span><b className="font-mono text-sm">{r.number}</b><br /><span className="text-xs text-slate-500">{r.doctor.display_name} · {fmtDate(r.issued_at)} · {r.items.length} medicine(s)</span></span></span>
            <StatusBadge status={r.status} />
          </Link>
        ))}
      </section>
    </div>
  );
}
